/** Data-testid catalogue for admin console (Phase 2). */

export const ADMIN = {
  // Dashboard
  dashboardRoot: "admin-dashboard",
  kpi: (key) => `kpi-${key}`,
  chart: (key) => `chart-${key}`,
  recentActivity: "recent-activity",

  // Users
  usersListRoot: "admin-users-list",
  usersTable: "admin-users-table",
  usersSearch: "admin-users-search",
  usersRoleFilter: "admin-users-role-filter",
  usersStatusFilter: "admin-users-status-filter",
  usersOrgFilter: "admin-users-org-filter",
  usersAddBtn: "admin-users-add-btn",
  usersRow: (id) => `admin-users-row-${id}`,
  usersRowView: (id) => `admin-users-view-${id}`,
  usersRowEdit: (id) => `admin-users-edit-${id}`,
  usersRowMore: (id) => `admin-users-more-${id}`,
  userFormRoot: "admin-user-form",
  userFormSubmit: "admin-user-form-submit",
  userFormFirst: "admin-user-form-first",
  userFormLast: "admin-user-form-last",
  userFormEmail: "admin-user-form-email",
  userFormMobile: "admin-user-form-mobile",
  userFormRole: "admin-user-form-role",
  userFormOrg: "admin-user-form-org",
  userFormDept: "admin-user-form-dept",
  userFormDesignation: "admin-user-form-designation",
  userFormEmployeeId: "admin-user-form-employeeid",
  userFormStatus: "admin-user-form-status",
  userFormPassword: "admin-user-form-password",
  userFormConfirm: "admin-user-form-confirm",
  userDetailRoot: "admin-user-detail",
  userDetailEdit: "admin-user-detail-edit",
  userDetailReset: "admin-user-detail-reset",
  userDetailSuspend: "admin-user-detail-suspend",
  userDetailActivate: "admin-user-detail-activate",
  resetDialogNew: "reset-dialog-new",
  resetDialogConfirm: "reset-dialog-confirm",
  resetDialogSubmit: "reset-dialog-submit",

  // Roles
  rolesRoot: "admin-roles-matrix",
  rolesSearch: "admin-roles-search",
  rolesModuleFilter: "admin-roles-module-filter",

  // Orgs
  orgsRoot: "admin-orgs-list",
  orgsSearch: "admin-orgs-search",
  orgsTypeFilter: "admin-orgs-type-filter",
  orgsStatusFilter: "admin-orgs-status-filter",
  orgRow: (id) => `admin-orgs-row-${id}`,
  orgDetailRoot: "admin-org-detail",

  // Settings
  settingsRoot: "admin-platform-settings",
  settingsSaveGeneral: "admin-settings-save-general",
  settingsSaveBranding: "admin-settings-save-branding",
  settingsSaveSecurity: "admin-settings-save-security",
  settingsSaveLms: "admin-settings-save-lms",
  settingsInput: (key) => `admin-settings-input-${key}`,

  // CMS
  cmsRoot: "admin-cms",
  cmsSubmit: "admin-cms-submit",
  cmsInput: (key) => `admin-cms-input-${key}`,

  // Audit
  auditRoot: "admin-audit-logs",
  auditSearch: "admin-audit-search",
  auditActionFilter: "admin-audit-action-filter",
  auditModuleFilter: "admin-audit-module-filter",
  auditDateFrom: "admin-audit-date-from",
  auditDateTo: "admin-audit-date-to",
  auditRow: (id) => `admin-audit-row-${id}`,

  // Health
  healthRoot: "admin-system-health",
  healthService: (key) => `health-service-${key}`,

  // Notifications
  notificationsRoot: "admin-notifications",
  notificationRow: (id) => `admin-notification-${id}`,
  notificationMarkRead: (id) => `admin-notification-mark-${id}`,
  notificationDelete: (id) => `admin-notification-delete-${id}`,
  notificationsMarkAll: "admin-notifications-mark-all",

  // Future modules
  futureRoot: "admin-future-modules",

  // Staff (Phase 4)
  staffListRoot: "staff-list",
  staffTable: "staff-table",
  staffSearch: "staff-search",
  staffRoleFilter: "staff-role-filter",
  staffStatusFilter: "staff-status-filter",
  staffDeptFilter: "staff-dept-filter",
  staffOrgFilter: "staff-org-filter",
  staffAddBtn: "staff-add-btn",
  staffImportBtn: "staff-import-btn",
  staffRow: (id) => `staff-row-${id}`,
  staffRowView: (id) => `staff-view-${id}`,
  staffRowEdit: (id) => `staff-edit-${id}`,
  staffRowMore: (id) => `staff-more-${id}`,
  staffFormRoot: "staff-form",
  staffFormSubmit: "staff-form-submit",
  staffFormFirst: "staff-form-first",
  staffFormLast: "staff-form-last",
  staffFormEmail: "staff-form-email",
  staffFormMobile: "staff-form-mobile",
  staffFormEmpId: "staff-form-empid",
  staffFormRole: "staff-form-role",
  staffFormDept: "staff-form-dept",
  staffFormDesignation: "staff-form-designation",
  staffFormManager: "staff-form-manager",
  staffFormStatus: "staff-form-status",
  staffFormJoining: "staff-form-joining",
  staffFormCreateLogin: "staff-form-createlogin",
  staffFormAutoPw: "staff-form-autopw",
  staffFormPassword: "staff-form-password",
  staffDashboardRoot: "staff-dashboard",
  staffImportRoot: "staff-import",
  staffImportUpload: "staff-import-upload",
  staffImportTemplate: "staff-import-template",
  staffImportPreview: "staff-import-preview",
  staffImportConfirm: "staff-import-confirm",
  staffDetailRoot: "staff-detail",
  designationsRoot: "designations-list",
  designationsAddBtn: "designations-add-btn",
  designationForm: "designation-form",
  designationFormSubmit: "designation-form-submit",
};
